import React from "react";
import styled from "styled-components";
import CardGraphic from "../components/CardGraphic";
import { skills } from "../utils.js";
const SkillsC = styled.section`
  width: 100%;
  height: 100vh;

  position: absolute;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  h1 {
    width: 80%;

    font-family: Nunito;
    font-style: normal;
    font-weight: normal;
    font-size: 27.8px;
    line-height: 23px;
    color: #fff;
  }
  .container {
    width: 90%;
    display: flex;
    flex-wrap: wrap;
  justify-content:center;
    align-items: center;
    gap: 3em;
  }
  @media (max-width: 450px) {
    .ghost {
      width: 100%;
      height: 59px;
    }
  }
  @media (min-width: 450.1px) {
    .ghost {
        display:none;
      width: 100%;
      height: 59px;
    }
  }
`;
function Skills() {
  console.log(skills);
  return (
    <>
      <SkillsC>
        <h1>My Skills</h1>
        <div className="container">
          {skills.map((e, index = 0) => (
            <CardGraphic key={index} {...e} />
          ))}
          <div className="ghost"></div>
        </div>
      </SkillsC>
    </>
  );
}

export default Skills;
